import axios from "axios";
import { API_URL } from "../constants";

export const fetch = (companyId, filtersValue, options = {}) => {
  const url = `${API_URL}/${companyId}/assets/fetch`;
  // Pagination is opt-in. Without `page` the backend returns the full bare
  // array (used by the asset/fuel-card selectors).
  const body = { filtersValue };
  if (options && options.page != null) {
    body.page = options.page;
    body.pageSize = options.pageSize;
  }
  return axios.post(url, body).then((response) => response.data);
};

export const post = (data, companyId) => {
  const url = `${API_URL}/${companyId}/assets/post`;
  return axios.post(url, data).then((response) => response.data);
};

export const patch = (data, companyId) => {
  const url = `${API_URL}/${companyId}/assets/${data.id}`;
  return axios.patch(url, data).then((response) => response.data);
};

export const fetchById = (companyId, assetId) => {
  const url = `${API_URL}/${companyId}/assets/${assetId}`;
  return axios.get(url).then((response) => response.data);
};

export const userAssign = (data, companyId) => {
  const url = `${API_URL}/${companyId}/assets/${data.id}`;
  return axios.post(url, data).then((response) => response.data);
};

export const fetchUserAssets = (companyId, options = {}) => {
  const params = new URLSearchParams();
  if (options.page !== undefined) {
    params.set("page", String(options.page));
  }
  if (options.pageSize !== undefined) {
    params.set("pageSize", String(options.pageSize));
  }
  const qs = params.toString();
  const url = `${API_URL}/${companyId}/user/assets${qs ? `?${qs}` : ""}`;
  return axios.get(url).then((response) => response.data);
};

export const assetPostFile = (data, companyId) => {
  const url = `${API_URL}/${companyId}/assets/${data.id}/post-file'`;
  return axios.post(url, data).then((response) => response.data);
};

export const assetReturn = (companyId, assetId, formData) => {
  const url = `${API_URL}/${companyId}/assets/${assetId}/return`;
  return axios.post(url, formData).then((response) => response.data);
};

export const assetForceReturn = (companyId, assetId) => {
  const url = `${API_URL}/${companyId}/assets/${assetId}/force-return`;
  return axios.post(url, {}).then((response) => response.data);
};
